import { View, ActivityIndicator } from 'react-native'
import { colorPalette, globalStyles } from '../../../static/styles/global'

export const Loading = (): JSX.Element => {
  return (
    <View
      style={[
        globalStyles.flexOne,
        globalStyles.hCenterItems,
        globalStyles.lightBgColor
      ]}
    >
      <ActivityIndicator
        color={colorPalette.secondary}
        animating={true}
        size={'large'}
      />
    </View>
  )
}
